/* eslint-disable -- UX wireframe import; not held to app lint rules */
import React, { useState, useEffect, useRef } from "react";
import PrototypeChrome from "../../shared/PrototypeChrome";

// ─── BRAND TOKENS ─────────────────────────────────────────────────────────────
const T = {
  brand:"#5e4ce2",brandHover:"#5046d4",brandSoft:"rgba(94,76,226,0.12)",brandBorder:"rgba(94,76,226,0.28)",
  cyan:"#06b6d4",cyanSoft:"rgba(6,182,212,0.1)",teal:"#14b8a6",tealSoft:"rgba(20,184,166,0.1)",
  amber:"#f59e0b",amberSoft:"rgba(245,158,11,0.12)",coral:"#f97316",coralSoft:"rgba(249,115,22,0.1)",
  green:"#22c55e",greenSoft:"rgba(34,197,94,0.1)",red:"#ef4444",redSoft:"rgba(239,68,68,0.1)",
  violet:"#7c3aed",
  lCanvas:"#f8fafc",lSurface:"#ffffff",lMuted:"#f1f5f9",lBorder:"rgba(51,65,85,0.1)",lBorderMd:"rgba(51,65,85,0.18)",
  lText:"#0f172a",lTextSec:"#475569",lTextMuted:"#94a3b8",
  dCanvas:"#0a0d12",dSurface:"#111318",dElevated:"#181c23",dMuted:"#1e2330",
  dBorder:"rgba(255,255,255,0.08)",dBorderMd:"rgba(255,255,255,0.14)",
  dText:"#f1f5f9",dTextSec:"#b0bec5",dTextMuted:"#64748b",
  fast:"150ms",mid:"220ms",slow:"320ms",
  ease:"cubic-bezier(0.4,0,0.2,1)",spring:"cubic-bezier(0.34,1.56,0.64,1)",
  rsm:"6px",rmd:"10px",rlg:"16px",rxl:"24px",
};
function useTheme(dark){
  return {
    bg:dark?T.dCanvas:T.lCanvas,surface:dark?T.dSurface:T.lSurface,
    elevated:dark?T.dElevated:T.lSurface,muted:dark?T.dMuted:T.lMuted,
    border:dark?T.dBorder:T.lBorder,borderMd:dark?T.dBorderMd:T.lBorderMd,
    text:dark?T.dText:T.lText,textSec:dark?T.dTextSec:T.lTextSec,textMuted:dark?T.dTextMuted:T.lTextMuted,
    sidebar:dark?"#0d1017":T.lSurface,
    dark,tr:`all ${T.mid} ${T.ease}`,
  };
}

// ─── CONFIG ───────────────────────────────────────────────────────────────────
const SUPER_ADMIN_CONFIG = {
  TOUR:{ ENABLED:true, IDLE_DAYS_TRIGGER:30, VERSION:"1.0.0" },
  CASHFREE:{ ENV:"sandbox", BASE_URL:"https://sandbox.cashfree.com/pg", LINK_EXPIRY_MINUTES:1440, CURRENCY:"INR" },
  SUBSCRIPTION:{ VALIDITY_OPTIONS:["monthly","quarterly","annual"], VALIDITY_DAYS:{monthly:30,quarterly:90,annual:365}, MAX_EXTENSION_DAYS:365, DEFAULT_EXTENSION_DAYS:30 },
  APPS:[
    {id:"zinihub",  label:"ZiniHub",  emoji:"🏪",color:T.brand, desc:"Multi-biz merchant platform"},
    {id:"zinishop", label:"ZiniShop", emoji:"🛒",color:T.teal,  desc:"Coming soon",disabled:true},
    {id:"zinibook",label:"ZiniBook", emoji:"📅",color:T.amber, desc:"Coming soon",disabled:true},
  ],
};

// ─── MOCK DATA ────────────────────────────────────────────────────────────────
const MOCK_PLANS = [
  {id:"trial",      label:"Trial",        color:T.amber,  colorSoft:T.amberSoft, rank:0, price:{monthly:0,   quarterly:0,    annual:0},     limits:{maxStores:1, maxItemsPerStore:10,  maxImagesPerItem:3,  maxStaffAccounts:1,  maxMediaStorageMB:100,   enableKYC:false,enableOrders:false,enableAnalytics:false}},
  {id:"starter",    label:"Starter",      color:T.cyan,   colorSoft:T.cyanSoft,  rank:1, price:{monthly:299, quarterly:799,  annual:2999},   limits:{maxStores:2, maxItemsPerStore:50,  maxImagesPerItem:5,  maxStaffAccounts:2,  maxMediaStorageMB:500,   enableKYC:true, enableOrders:true, enableAnalytics:false}},
  {id:"professional",label:"Professional",color:T.brand,  colorSoft:T.brandSoft, rank:2, price:{monthly:799, quarterly:2099, annual:7999},   limits:{maxStores:10,maxItemsPerStore:500, maxImagesPerItem:10, maxStaffAccounts:10, maxMediaStorageMB:5000,  enableKYC:true, enableOrders:true, enableAnalytics:true}},
  {id:"enterprise", label:"Enterprise",   color:T.violet, colorSoft:"rgba(124,58,237,0.1)",rank:3,price:{monthly:1999,quarterly:5499,annual:19999},limits:{maxStores:-1,maxItemsPerStore:-1,maxImagesPerItem:20,maxStaffAccounts:-1, maxMediaStorageMB:50000, enableKYC:true, enableOrders:true, enableAnalytics:true}},
];
const MOCK_HUBS = [
  {id:"hub22",name:"Hub22 - Bengaluru Foods", owner:"Ravi Kumar", mobile:"+91 98765 43210",plan:"professional",validity:"monthly",  startDate:"2026-03-12",expiryDate:"2026-08-12",status:"active",      app:"zinihub"},
  {id:"hub45",name:"Craft Corner Studio",     owner:"Priya Mehta", mobile:"+91 87654 32109",plan:"starter",     validity:"quarterly",startDate:"2026-01-05",expiryDate:"2026-05-18",status:"expiring_soon",app:"zinihub"},
  {id:"hub99",name:"TechGuru Electronics",    owner:"Suresh Nair", mobile:"+91 76543 21098",plan:"trial",       validity:"monthly",  startDate:"2026-04-20",expiryDate:"2026-05-20",status:"expired",      app:"zinihub"},
  {id:"hub12",name:"Blossom Bakehouse",       owner:"Anjali Singh",mobile:"+91 65432 10987",plan:"enterprise",  validity:"annual",   startDate:"2026-01-01",expiryDate:"2027-01-01",status:"active",       app:"zinihub"},
  {id:"hub77",name:"FitLife Gym & Spa",       owner:"Vikram Patel",mobile:"+91 54321 09876",plan:"professional",validity:"quarterly",startDate:"2026-02-14",expiryDate:"2026-06-30",status:"active",       app:"zinihub"},
];

// ─── TOUR STEPS ───────────────────────────────────────────────────────────────
const TOUR_STEPS = [
  {id:"welcome",      target:null,             title:"Welcome to ZiniZ Super Admin 👋", body:"Command centre for all ZiniZ apps. Let's walk through the two core modules — Subscriptions and Plan Manager.", action:"Start Tour"},
  {id:"nav_app",      target:"app-switcher",   title:"App switcher",                    body:"Switch between ZiniZ apps here. Today it's ZiniHub — ZiniShop and ZiniBook coming soon. Plans and subscriptions are always scoped to the selected app.", action:"Next →"},
  {id:"nav_sub",      target:"nav-sub",        title:"Subscriptions module",            body:"Find any hub by name or owner. Extend validity, change plans, generate Cashfree payment links, or reset passwords.", action:"Next →"},
  {id:"sub_search",   target:"sub-search",     title:"Search hubs",                     body:"Type a hub name, owner name, or mobile number. Results filter in real time.", action:"Next →"},
  {id:"sub_table",    target:"sub-table-head", title:"Hub subscription table",          body:"Each row shows plan, validity, expiry, and status. Use the ⋯ menu on any row for actions.", action:"Next →"},
  {id:"nav_plans",    target:"nav-plans",      title:"Plan Manager module",             body:"Define plans available in each app — names, prices and feature limits.", action:"Next →"},
  {id:"plan_cards",   target:"plan-limits",    title:"Limits are live config",          body:"Every limit here maps to your zinihubConfig.js constants — editable from this UI and pushed to DB/S3 without a redeploy.", action:"Next →"},
  {id:"done",         target:null,             title:"You're all set ✓",                body:"Subscriptions and Plan Manager covered. Users, App Config, Feature Flags, and Audit Log are on the roadmap.", action:"Finish"},
];

// ─── BRAND GUIDE DATA ─────────────────────────────────────────────────────────
const BRAND_COLORS = [
  {name:"Brand Violet",  hex:"#5E4CE2",role:"Primary actions, active states, brand accent"},
  {name:"Brand Hover",   hex:"#5046D4",role:"Hover state for primary buttons"},
  {name:"Cyan",          hex:"#06B6D4",role:"Starter plan, info accents"},
  {name:"Teal",          hex:"#14B8A6",role:"Success alt, ZiniShop brand"},
  {name:"Amber",         hex:"#F59E0B",role:"Warning, trial plan, expiring soon"},
  {name:"Green",         hex:"#22C55E",role:"Active status, success toasts"},
  {name:"Red",           hex:"#EF4444",role:"Danger, expired, destructive actions"},
  {name:"Violet",        hex:"#7C3AED",role:"Enterprise plan"},
  {name:"Dark Canvas",   hex:"#0A0D12",role:"Dark mode page background"},
  {name:"Dark Surface",  hex:"#111318",role:"Dark mode card background"},
  {name:"Dark Modal",    hex:"#2C3149",role:"Dark mode modal (must contrast with canvas)"},
  {name:"Light Canvas",  hex:"#F8FAFC",role:"Light mode page background"},
  {name:"Light Surface", hex:"#FFFFFF", role:"Light mode card background"},
];
const TOKEN_TABLE = [
  ["rsm","6px","Badges, pills, small chips"],
  ["rmd","10px","Inputs, buttons, dropdowns"],
  ["rlg","16px","Cards, panels, table wrappers"],
  ["rxl","24px","Modals, drawer panels"],
  ["fast","150ms","Hover states, button presses"],
  ["mid","220ms","Sidebar toggle, dropdown open"],
  ["ease","cubic-bezier(0.4,0,0.2,1)","Standard easing (all transitions)"],
];
const BREAKPOINTS = [
  ["≥ 1280px","Primary target","Sidebar 210px expanded. 4-col stats. Full table."],
  ["1024–1279px","Laptop","Sidebar auto-collapses to 58px. Table scrollable."],
  ["768–1023px","Tablet","Sidebar collapsed. Padding 16px. Plan cards 2-col."],
  ["< 768px","Not supported","Show desktop-only banner. Super admin is desktop-first."],
];
const IA_MODULES = [
  {id:"subscriptions",icon:"💳",label:"Subscriptions",status:"live",   desc:"Search hubs · Extend validity · Change plan · Cashfree pay link · Reset PW"},
  {id:"plans",        icon:"📦",label:"Plan Manager",  status:"live",   desc:"Define plans · Set pricing (monthly/quarterly/annual) · Feature limits"},
  {id:"users",        icon:"👥",label:"Users",          status:"roadmap",desc:"Search users · View profile · Ban/unban · Force role change"},
  {id:"app_config",   icon:"⚙️", label:"App Config",    status:"roadmap",desc:"Edit zinihubConfig constants per app, stored in S3"},
  {id:"feature_flags",icon:"🚩",label:"Feature Flags",  status:"roadmap",desc:"Toggle features on/off per app or per hub"},
  {id:"audit_log",    icon:"📋",label:"Audit Log",      status:"roadmap",desc:"Super admin action history: actor · target · timestamp · action"},
];
const USER_FLOWS = [
  {id:"extend",color:T.brand,label:"Extend Hub Validity",steps:[
    {s:"Find hub",n:"Search by name, owner, or mobile"},
    {s:"Click ⋯ → Extend validity",n:"Opens inline modal"},
    {s:"Enter days",n:"Max 365 (SUPER_ADMIN_CONFIG). Preview new expiry computed live."},
    {s:"Confirm",n:"API: PATCH /hubs/{id}/subscription → extend. Toast + audit log."},
  ]},
  {id:"payment",color:T.green,label:"Generate Payment Link",steps:[
    {s:"Find hub → ⋯ → Generate pay link",n:"Modal opens with current plan pre-selected"},
    {s:"Select Plan + Validity",n:"Amount auto-computes from plan pricing matrix"},
    {s:"Click Generate",n:"POST /pg/links Cashfree API via backend proxy"},
    {s:"Copy link",n:"Share with hub owner via WhatsApp/SMS. Link expires per CASHFREE.LINK_EXPIRY_MINUTES."},
  ]},
  {id:"reset",color:T.red,label:"Reset Password",steps:[
    {s:"Find hub → ⋯ → Reset password",n:"Modal shows registered mobile"},
    {s:"Confirm Send Reset SMS",n:"Backend triggers OTP to owner mobile"},
    {s:"Action logged",n:"Audit trail: actor (SA user ID), target (hub/user ID), timestamp"},
  ]},
  {id:"plan_change",color:T.amber,label:"Change Plan",steps:[
    {s:"Find hub → ⋯ → Change plan",n:"Warning: immediate override"},
    {s:"Select new plan + validity",n:"Confirm payment received before proceeding"},
    {s:"Confirm",n:"API: PATCH /hubs/{id}/subscription → new plan. Toast + audit."},
  ]},
  {id:"tour",color:T.cyan,label:"First-Time Tour",steps:[
    {s:"Login check",n:"Read localStorage 'ziniz_sa_last_tour_v2'. Show if absent or > IDLE_DAYS_TRIGGER days"},
    {s:"Tour starts after 600ms",n:"position:fixed overlay · SVG clip-path spotlight"},
    {s:"8 steps with scroll-into-view",n:"Tooltip flips above/below based on viewport space"},
    {s:"Finish/Skip",n:"Write timestamp to localStorage. Re-trigger via 🧭 Site tour in sidebar."},
  ]},
];
const CONFIG_KEYS = [
  ["TOUR.ENABLED",                   "bool",   "Master switch for tour feature"],
  ["TOUR.IDLE_DAYS_TRIGGER",         "number", "Days of inactivity before tour auto-shows again (default 30)"],
  ["TOUR.VERSION",                   "string", "Bump version suffix to reset all users' tour-seen state"],
  ["CASHFREE.ENV",                   "enum",   "'sandbox' | 'production'"],
  ["CASHFREE.LINK_EXPIRY_MINUTES",   "number", "Payment link TTL in minutes (default 1440 = 24h)"],
  ["CASHFREE.CURRENCY",              "string", "INR"],
  ["SUBSCRIPTION.MAX_EXTENSION_DAYS","number", "Hard cap on extend validity input"],
  ["SUBSCRIPTION.DEFAULT_EXTENSION_DAYS","number","Pre-filled value in extend modal"],
  ["APPS",                           "array",  "App registry: { id, label, emoji, color, desc, disabled }"],
];

// ─── ATOMS ────────────────────────────────────────────────────────────────────
function Badge({label,color,bg}){
  return <span style={{fontSize:11,fontWeight:600,padding:"2px 8px",borderRadius:99,background:bg||`${color}18`,color,letterSpacing:"0.02em",whiteSpace:"nowrap"}}>{label}</span>;
}
function StatusBadge({status}){
  const m={active:[T.green,T.greenSoft,"Active"],expiring_soon:[T.amber,T.amberSoft,"Expiring Soon"],expired:[T.red,T.redSoft,"Expired"]};
  const [c,bg,label]=m[status]||m.active;
  return <Badge label={label} color={c} bg={bg}/>;
}
function PlanBadge({planId}){
  const p=MOCK_PLANS.find(x=>x.id===planId);
  return p?<Badge label={p.label} color={p.color} bg={p.colorSoft}/>:null;
}
function Btn({children,onClick,variant="primary",size="md",disabled,style:s}){
  const base={border:"none",cursor:disabled?"not-allowed":"pointer",fontFamily:"inherit",fontWeight:500,borderRadius:T.rmd,transition:`all ${T.fast} ${T.ease}`,opacity:disabled?0.45:1,whiteSpace:"nowrap"};
  const sz={xs:{fontSize:11,padding:"3px 8px"},sm:{fontSize:12,padding:"5px 11px"},md:{fontSize:13,padding:"7px 16px"}};
  const v={primary:{background:T.brand,color:"#fff"},ghost:{background:"transparent",color:T.brand,border:`1px solid ${T.brandBorder}`},danger:{background:T.redSoft,color:T.red},success:{background:T.greenSoft,color:T.green},amber:{background:T.amberSoft,color:T.amber},neutral:{background:"rgba(255,255,255,0.07)",color:"#b0bec5",border:"1px solid rgba(255,255,255,0.1)"}};
  return <button onClick={disabled?undefined:onClick} style={{...base,...sz[size],...(v[variant]||v.primary),...s}}>{children}</button>;
}
function FInput({value,onChange,placeholder,type="text",style:s}){
  return <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
    style={{fontSize:13,padding:"7px 12px",borderRadius:T.rmd,border:"1px solid rgba(100,116,139,0.3)",fontFamily:"inherit",outline:"none",background:"rgba(255,255,255,0.04)",color:"inherit",width:"100%",boxSizing:"border-box",...s}}/>;
}
function FSelect({value,onChange,children,dark,style:s}){
  return <select value={value} onChange={e=>onChange(e.target.value)}
    style={{fontSize:13,padding:"7px 10px",borderRadius:T.rmd,border:"1px solid rgba(100,116,139,0.3)",fontFamily:"inherit",outline:"none",background:dark?T.dMuted:T.lSurface,color:"inherit",...s}}>{children}</select>;
}
function FL({children}){return <div style={{fontSize:11,color:"#64748b",marginBottom:4,fontWeight:500,letterSpacing:"0.03em"}}>{children}</div>;}
function InfoStrip({children}){return <div style={{background:"rgba(94,76,226,0.12)",border:"1px solid rgba(94,76,226,0.2)",borderRadius:T.rmd,padding:"8px 12px",marginBottom:16,fontSize:12,color:"#c4b5fd",display:"flex",gap:14,flexWrap:"wrap",alignItems:"center"}}>{children}</div>;}
function WarnStrip({children}){return <div style={{background:T.amberSoft,border:`1px solid rgba(245,158,11,0.3)`,borderRadius:T.rmd,padding:"8px 12px",marginBottom:16,fontSize:12,color:T.amber}}>{children}</div>;}

// ─── MODAL ────────────────────────────────────────────────────────────────────
// position:absolute — anchored to the scrollable content area (NOT fixed — iframe safe)
function Modal({onClose,title,subtitle,children,width=440}){
  return(
    <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.65)",zIndex:200,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:48,paddingLeft:16,paddingRight:16}}>
      <div style={{background:"#2c3149",borderRadius:T.rxl,borderLeft:`3px solid ${T.brand}`,border:"1px solid rgba(94,76,226,0.4)",borderLeftWidth:"3px",padding:"22px 26px",width,maxWidth:"100%",maxHeight:"82vh",overflowY:"auto",boxShadow:"0 24px 64px rgba(0,0,0,0.7),0 0 0 1px rgba(94,76,226,0.15)",flexShrink:0,color:"#f1f5f9"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:"#f1f5f9"}}>{title}</div>
            {subtitle&&<div style={{fontSize:12,color:"#94a3b8",marginTop:2}}>{subtitle}</div>}
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:T.rsm,cursor:"pointer",color:"#cbd5e1",fontSize:14,lineHeight:1,padding:"3px 9px",marginLeft:12,flexShrink:0}}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ─── TOUR OVERLAY — position:fixed + canvas-based dim with real cutout ────────
function TourOverlay({step,stepIdx,total,onNext,onSkip,targetRefs}){
  const canvasRef = useRef(null);
  const [spot, setSpot] = useState(null);
  const [tipPos, setTipPos] = useState(null);
  const TIP_W=308, TIP_H=200;

  // Draw the dim + cutout on canvas
  useEffect(()=>{
    const canvas = canvasRef.current;
    if(!canvas) return;
    const vw = window.innerWidth, vh = window.innerHeight;
    canvas.width = vw; canvas.height = vh;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0,0,vw,vh);
    ctx.fillStyle = "rgba(0,0,0,0.62)";
    if(spot){
      const {x,y,w,h,r} = spot;
      // Full screen fill with even-odd rule cutout
      ctx.beginPath();
      ctx.rect(0,0,vw,vh);
      // Rounded rect cutout (clockwise = fill, counterclockwise = hole)
      const pad=6;
      // Clamp so ring never bleeds outside canvas (min x = 1px)
      const rx=Math.max(1,x-pad), ry=Math.max(1,y-pad), rw=Math.min(w+pad*2, canvas.width-rx-1), rh=Math.min(h+pad*2, canvas.height-ry-1), cr=r;
      ctx.moveTo(rx+cr,ry);
      ctx.lineTo(rx+rw-cr,ry); ctx.arcTo(rx+rw,ry,rx+rw,ry+cr,cr);
      ctx.lineTo(rx+rw,ry+rh-cr); ctx.arcTo(rx+rw,ry+rh,rx+rw-cr,ry+rh,cr);
      ctx.lineTo(rx+cr,ry+rh); ctx.arcTo(rx,ry+rh,rx,ry+rh-cr,cr);
      ctx.lineTo(rx,ry+cr); ctx.arcTo(rx,ry,rx+cr,ry,cr);
      ctx.closePath();
      ctx.fill("evenodd");
      // Brand ring
      ctx.strokeStyle = T.brand;
      ctx.lineWidth = 2.5;
      ctx.beginPath();
      ctx.moveTo(rx+cr,ry);
      ctx.lineTo(rx+rw-cr,ry); ctx.arcTo(rx+rw,ry,rx+rw,ry+cr,cr);
      ctx.lineTo(rx+rw,ry+rh-cr); ctx.arcTo(rx+rw,ry+rh,rx+rw-cr,ry+rh,cr);
      ctx.lineTo(rx+cr,ry+rh); ctx.arcTo(rx,ry+rh,rx,ry+rh-cr,cr);
      ctx.lineTo(rx,ry+cr); ctx.arcTo(rx,ry,rx+cr,ry,cr);
      ctx.closePath();
      ctx.stroke();
    } else {
      ctx.fillRect(0,0,vw,vh);
    }
  },[spot]);

  useEffect(()=>{
    const calc = ()=>{
      if(step.target && targetRefs.current[step.target]){
        const el = targetRefs.current[step.target];
        el.scrollIntoView({behavior:"smooth",block:"nearest"});
        setTimeout(()=>{
          const r = el.getBoundingClientRect();
          const vw=window.innerWidth, vh=window.innerHeight;
          setSpot({x:r.left,y:r.top,w:r.width,h:r.height,r:8});
          // Tooltip: prefer below, flip above if tight
          const pad=12;
          let tTop = r.bottom + pad;
          if(tTop + TIP_H > vh-10) tTop = Math.max(10, r.top - TIP_H - pad);
          let tLeft = Math.max(pad, Math.min(r.left, vw - TIP_W - pad));
          setTipPos({top:tTop,left:tLeft});
        },180);
      } else {
        setSpot(null);
        const vw=window.innerWidth, vh=window.innerHeight;
        setTipPos({top:Math.max(80,vh/2-TIP_H/2),left:Math.max(12,vw/2-TIP_W/2)});
      }
    };
    calc();
  },[step]);

  if(!tipPos) return null;
  return(
    <div style={{position:"fixed",inset:0,zIndex:9000,pointerEvents:"none"}}>
      {/* Canvas: single source of dim + real cutout hole — no double-dim */}
      <canvas ref={canvasRef} style={{position:"absolute",top:0,left:0,pointerEvents:"none"}}/>
      {/* Tooltip — interactive */}
      <div style={{position:"absolute",top:tipPos.top,left:tipPos.left,width:TIP_W,pointerEvents:"all",background:"#1e2540",border:`2px solid ${T.brand}`,borderRadius:T.rlg,padding:"16px 18px",boxShadow:"0 12px 44px rgba(0,0,0,0.65)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
          <span style={{fontSize:11,color:T.brand,fontWeight:600}}>{stepIdx+1} / {total}</span>
          <button onClick={onSkip} style={{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:T.rsm,cursor:"pointer",color:"#94a3b8",fontSize:14,lineHeight:1,padding:"2px 7px"}}>×</button>
        </div>
        <div style={{fontWeight:700,fontSize:13,color:"#f1f5f9",marginBottom:6}}>{step.title}</div>
        <div style={{fontSize:12,color:"#94a3b8",lineHeight:1.65,marginBottom:14}}>{step.body}</div>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={onNext} size="sm">{step.action}</Btn>
          {stepIdx<total-1&&<Btn onClick={onSkip} variant="neutral" size="sm">Skip tour</Btn>}
        </div>
        <div style={{display:"flex",gap:3,marginTop:12}}>
          {Array.from({length:total}).map((_,i)=>(
            <div key={i} style={{width:i===stepIdx?14:5,height:5,borderRadius:99,background:i===stepIdx?T.brand:"rgba(255,255,255,0.18)",transition:`width ${T.mid} ${T.ease}`}}/>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── ACTION MENU ──────────────────────────────────────────────────────────────
function ActionMenu({hub,th,onAction}){
  const [open,setOpen]=useState(false);
  const ref=useRef(null);
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    if(open)document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[open]);
  const actions=[
    {id:"extend",     label:"Extend validity",   color:T.brand},
    {id:"payment",    label:"Generate pay link",  color:T.green},
    {id:"change_plan",label:"Change plan",        color:T.amber},
    {id:"reset_pw",   label:"Reset password",     color:T.red},
  ];
  return(
    <div ref={ref} style={{position:"relative"}}>
      <button onClick={()=>setOpen(v=>!v)} style={{background:open?T.brandSoft:"rgba(255,255,255,0.05)",border:`1px solid ${open?T.brandBorder:"rgba(255,255,255,0.1)"}`,color:open?T.brand:th.textSec,borderRadius:T.rmd,cursor:"pointer",fontSize:16,padding:"3px 10px",fontFamily:"inherit",transition:`all ${T.fast} ${T.ease}`}}>⋯</button>
      {open&&(
        <div style={{position:"absolute",right:0,top:"calc(100% + 6px)",zIndex:100,background:th.dark?"#252c3d":"#fff",border:`1px solid ${th.dark?"rgba(255,255,255,0.12)":T.lBorderMd}`,borderRadius:T.rmd,padding:"4px",minWidth:175,boxShadow:"0 8px 24px rgba(0,0,0,0.35)"}}>
          {actions.map(a=>(
            <div key={a.id} onClick={()=>{onAction(hub,a.id);setOpen(false);}} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 11px",borderRadius:T.rmd,cursor:"pointer",fontSize:12,color:th.text,transition:`background ${T.fast}`}}
              onMouseEnter={e=>e.currentTarget.style.background=th.dark?"rgba(255,255,255,0.06)":T.lMuted}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{width:6,height:6,borderRadius:"50%",background:a.color,flexShrink:0}}/>
              {a.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── SUBSCRIPTION MODULE ──────────────────────────────────────────────────────
function SubscriptionModule({th,targetRefs}){
  const [search,setSearch]=useState("");
  const [statusFilter,setStatusFilter]=useState("all");
  const [actionHub,setActionHub]=useState(null);
  const [actionType,setActionType]=useState(null);
  const [extendDays,setExtendDays]=useState(String(SUPER_ADMIN_CONFIG.SUBSCRIPTION.DEFAULT_EXTENSION_DAYS));
  const [paymentPlan,setPaymentPlan]=useState("professional");
  const [paymentValidity,setPaymentValidity]=useState("monthly");
  const [generatedLink,setGeneratedLink]=useState(null);
  const [changePlan,setChangePlan]=useState("professional");
  const [changeValidity,setChangeValidity]=useState("monthly");
  const [toast,setToast]=useState(null);

  const showToast=(msg,type="success")=>{setToast({msg,type});setTimeout(()=>setToast(null),3000);};
  const openAction=(hub,type)=>{setActionHub(hub);setActionType(type);setGeneratedLink(null);};
  const closeAction=()=>{setActionHub(null);setActionType(null);};

  const filtered=MOCK_HUBS.filter(h=>{
    const q=search.toLowerCase();
    return(!q||h.name.toLowerCase().includes(q)||h.owner.toLowerCase().includes(q)||h.mobile.includes(q))&&(statusFilter==="all"||h.status===statusFilter);
  });

  const newExpiry=()=>{const d=new Date(actionHub?.expiryDate||"");d.setDate(d.getDate()+parseInt(extendDays||0));return d.toISOString().split("T")[0];};
  const card={background:th.surface,border:`1px solid ${th.border}`,borderRadius:T.rlg};
  const STATS=[["Total Hubs",MOCK_HUBS.length,T.brand],["Active",MOCK_HUBS.filter(h=>h.status==="active").length,T.green],["Expiring Soon",MOCK_HUBS.filter(h=>h.status==="expiring_soon").length,T.amber],["Expired",MOCK_HUBS.filter(h=>h.status==="expired").length,T.red]];

  return(
    <div style={{maxWidth:1000,position:"relative"}}>
      {toast&&<div style={{position:"absolute",top:-16,right:0,zIndex:50,background:toast.type==="success"?T.green:T.red,color:"#fff",padding:"8px 18px",borderRadius:T.rmd,fontSize:13,fontWeight:500}}>{toast.msg}</div>}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:20,fontWeight:700,color:th.text,marginBottom:3}}>Subscriptions</div>
        <div style={{fontSize:13,color:th.textSec}}>Search hubs, manage plans, extend validity, generate payment links.</div>
      </div>
      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:22}}>
        {STATS.map(([label,val,col])=>(
          <div key={label} style={{...card,padding:"14px 18px"}}>
            <div style={{fontSize:11,color:th.textMuted,marginBottom:4}}>{label}</div>
            <div style={{fontSize:28,fontWeight:700,color:col}}>{val}</div>
          </div>
        ))}
      </div>
      {/* Search */}
      <div ref={el=>targetRefs.current["sub-search"]=el} style={{...card,padding:"12px 16px",marginBottom:14,display:"flex",gap:10,alignItems:"center"}}>
        <div style={{flex:1}}><FInput value={search} onChange={setSearch} placeholder="Search by hub name, owner, mobile…"/></div>
        <FSelect dark={th.dark} value={statusFilter} onChange={setStatusFilter}>
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="expiring_soon">Expiring Soon</option>
          <option value="expired">Expired</option>
        </FSelect>
        <div style={{fontSize:12,color:th.textMuted,whiteSpace:"nowrap"}}>{filtered.length} result{filtered.length!==1?"s":""}</div>
      </div>
      {/* Table */}
      <div style={{...card,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead>
            <tr ref={el=>targetRefs.current["sub-table-head"]=el} style={{background:th.muted,borderBottom:`1px solid ${th.border}`}}>
              {["Hub","Owner","Plan","Validity","Expiry","Status","Actions"].map(h=>(
                <th key={h} style={{textAlign:"left",padding:"9px 13px",fontWeight:600,color:th.textSec,fontSize:11,letterSpacing:"0.04em"}}>{h.toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((hub,i)=>{
              const daysLeft=Math.round((new Date(hub.expiryDate)-new Date())/(1000*60*60*24));
              return(
                <tr key={hub.id} style={{borderBottom:`1px solid ${th.border}`,background:i%2===0?"transparent":th.muted+"55"}}>
                  <td style={{padding:"10px 13px"}}><div style={{fontWeight:600,color:th.text}}>{hub.name}</div><div style={{fontSize:11,color:th.textMuted}}>{hub.id} · {hub.app}</div></td>
                  <td style={{padding:"10px 13px"}}><div style={{color:th.text}}>{hub.owner}</div><div style={{fontSize:11,color:th.textMuted}}>{hub.mobile}</div></td>
                  <td style={{padding:"10px 13px"}}><PlanBadge planId={hub.plan}/></td>
                  <td style={{padding:"10px 13px",color:th.textSec,textTransform:"capitalize"}}>{hub.validity}</td>
                  <td style={{padding:"10px 13px"}}>
                    <div style={{color:th.text}}>{hub.expiryDate}</div>
                    <div style={{fontSize:11,color:daysLeft<0?T.red:daysLeft<14?T.amber:th.textMuted}}>{daysLeft<0?`Expired ${Math.abs(daysLeft)}d ago`:daysLeft<14?`⚠ ${daysLeft}d left`:`${daysLeft}d left`}</div>
                  </td>
                  <td style={{padding:"10px 13px"}}><StatusBadge status={hub.status}/></td>
                  <td style={{padding:"10px 13px"}}><ActionMenu hub={hub} th={th} onAction={openAction}/></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Modals */}
      {actionHub&&actionType==="extend"&&(
        <Modal onClose={closeAction} title="Extend Validity" subtitle={`${actionHub.name} · ${actionHub.owner}`}>
          <InfoStrip><span>Current: <b>{actionHub.plan}</b></span><span>Expires: <b>{actionHub.expiryDate}</b></span><StatusBadge status={actionHub.status}/></InfoStrip>
          <FL>Days to extend (max {SUPER_ADMIN_CONFIG.SUBSCRIPTION.MAX_EXTENSION_DAYS})</FL>
          <FInput value={extendDays} onChange={setExtendDays} type="number" placeholder="e.g. 30" style={{marginBottom:8}}/>
          <div style={{fontSize:12,color:"#64748b",marginBottom:20}}>New expiry: <b style={{color:"#f1f5f9"}}>{newExpiry()}</b></div>
          <div style={{display:"flex",gap:10}}><Btn onClick={()=>{showToast(`✓ Extended ${actionHub.name} by ${extendDays} days`);closeAction();}}>Confirm Extension</Btn><Btn variant="ghost" onClick={closeAction}>Cancel</Btn></div>
        </Modal>
      )}
      {actionHub&&actionType==="payment"&&(
        <Modal onClose={closeAction} title="Generate Payment Link" subtitle={`${actionHub.name} · ${actionHub.owner}`} width={460}>
          <InfoStrip><span>Current plan: <b>{actionHub.plan}</b></span><span>Expires: <b>{actionHub.expiryDate}</b></span></InfoStrip>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
            <div><FL>Plan</FL><FSelect dark={th.dark} value={paymentPlan} onChange={setPaymentPlan} style={{width:"100%"}}>{MOCK_PLANS.filter(p=>p.id!=="trial").map(p=><option key={p.id} value={p.id}>{p.label}</option>)}</FSelect></div>
            <div><FL>Validity</FL><FSelect dark={th.dark} value={paymentValidity} onChange={setPaymentValidity} style={{width:"100%"}}>{SUPER_ADMIN_CONFIG.SUBSCRIPTION.VALIDITY_OPTIONS.map(v=><option key={v} value={v} style={{textTransform:"capitalize"}}>{v}</option>)}</FSelect></div>
          </div>
          <div style={{marginBottom:18,fontSize:13,color:"#b0bec5"}}>Amount: <span style={{fontSize:20,fontWeight:700,color:T.brand}}>₹{MOCK_PLANS.find(p=>p.id===paymentPlan)?.price[paymentValidity]||0}</span><span style={{fontSize:11,color:"#475569",marginLeft:8}}>· Cashfree {SUPER_ADMIN_CONFIG.CASHFREE.ENV}</span></div>
          {generatedLink?(
            <div style={{background:T.greenSoft,borderRadius:T.rmd,padding:"12px 14px",marginBottom:14}}>
              <div style={{fontSize:12,color:T.green,fontWeight:600,marginBottom:6}}>✓ Link generated</div>
              <div style={{fontSize:11,color:"#94a3b8",wordBreak:"break-all",marginBottom:10}}>{generatedLink.url}</div>
              <Btn size="sm" variant="success" onClick={()=>navigator.clipboard?.writeText(generatedLink.url).then(()=>showToast("✓ Copied to clipboard"))}>Copy Link</Btn>
            </div>
          ):(
            <Btn onClick={()=>{setGeneratedLink({url:`https://payments.cashfree.com/links/ziniz_${actionHub.id}_${paymentPlan}_${Date.now()}`});showToast("✓ Payment link generated");}}>Generate Cashfree Link</Btn>
          )}
          <div style={{marginTop:12}}><Btn variant="ghost" onClick={closeAction}>Close</Btn></div>
        </Modal>
      )}
      {actionHub&&actionType==="reset_pw"&&(
        <Modal onClose={closeAction} title="Reset Password" subtitle={`${actionHub.name} · ${actionHub.owner}`}>
          <InfoStrip><span>Mobile: <b>{actionHub.mobile}</b></span></InfoStrip>
          <div style={{fontSize:13,color:"#b0bec5",marginBottom:8}}>A password reset OTP will be sent via SMS to the registered number.</div>
          <div style={{fontSize:12,color:"#64748b",marginBottom:20}}>This action is logged in the audit trail.</div>
          <div style={{display:"flex",gap:10}}><Btn variant="danger" onClick={()=>{showToast(`✓ Reset SMS sent to ${actionHub.mobile}`);closeAction();}}>Send Reset SMS</Btn><Btn variant="ghost" onClick={closeAction}>Cancel</Btn></div>
        </Modal>
      )}
      {actionHub&&actionType==="change_plan"&&(
        <Modal onClose={closeAction} title="Change Plan" subtitle={`${actionHub.name} · ${actionHub.owner}`}>
          <InfoStrip><span>Current: <b>{actionHub.plan}</b></span><span>Expires: <b>{actionHub.expiryDate}</b></span></InfoStrip>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
            <div><FL>New Plan</FL><FSelect dark={th.dark} value={changePlan} onChange={setChangePlan} style={{width:"100%"}}>{MOCK_PLANS.map(p=><option key={p.id} value={p.id}>{p.label}</option>)}</FSelect></div>
            <div><FL>Validity</FL><FSelect dark={th.dark} value={changeValidity} onChange={setChangeValidity} style={{width:"100%"}}>{SUPER_ADMIN_CONFIG.SUBSCRIPTION.VALIDITY_OPTIONS.map(v=><option key={v} value={v} style={{textTransform:"capitalize"}}>{v}</option>)}</FSelect></div>
          </div>
          <WarnStrip>⚠ This overrides the hub's plan immediately. Ensure payment has been received or this is an admin-granted plan.</WarnStrip>
          <div style={{display:"flex",gap:10}}><Btn onClick={()=>{showToast(`✓ Plan changed to ${changePlan} (${changeValidity})`);closeAction();}}>Confirm Plan Change</Btn><Btn variant="ghost" onClick={closeAction}>Cancel</Btn></div>
        </Modal>
      )}
    </div>
  );
}

// ─── PLAN MANAGER MODULE ──────────────────────────────────────────────────────
function PlanManagerModule({th,targetRefs}){
  const [plans,setPlans]=useState(MOCK_PLANS);
  const [editingId,setEditingId]=useState(null);
  const [draft,setDraft]=useState(null);
  const [isNew,setIsNew]=useState(false);
  const [activeV,setActiveV]=useState("monthly");
  const [toast,setToast]=useState(null);

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(null),3000);};
  const startEdit=plan=>{setEditingId(plan.id);setDraft(JSON.parse(JSON.stringify(plan)));setIsNew(false);};
  const cancel=()=>{setEditingId(null);setDraft(null);};
  const save=()=>{if(isNew)setPlans(p=>[...p,draft]);else setPlans(p=>p.map(x=>x.id===draft.id?draft:x));showToast(`✓ "${draft.label}" saved → propagating to DB/S3`);cancel();};

  const LIMITS=[
    {key:"maxStores",label:"Max Stores",note:"-1 = unlimited",type:"num"},
    {key:"maxItemsPerStore",label:"Max Items / Store",note:"-1 = unlimited",type:"num"},
    {key:"maxImagesPerItem",label:"Max Images / Item",note:"Per listing",type:"num"},
    {key:"maxStaffAccounts",label:"Max Staff Accounts",note:"-1 = unlimited",type:"num"},
    {key:"maxMediaStorageMB",label:"Media Storage (MB)",note:"Total gallery per hub",type:"num"},
    {key:"enableKYC",label:"KYC Module",note:"",type:"bool"},
    {key:"enableOrders",label:"Orders Module",note:"",type:"bool"},
    {key:"enableAnalytics",label:"Analytics Module",note:"",type:"bool"},
  ];
  const card={background:th.surface,border:`1px solid ${th.border}`,borderRadius:T.rlg};

  return(
    <div style={{maxWidth:1000,position:"relative"}}>
      {toast&&<div style={{position:"absolute",top:-16,right:0,zIndex:50,background:T.green,color:"#fff",padding:"8px 18px",borderRadius:T.rmd,fontSize:13,fontWeight:500}}>{toast}</div>}
      <div style={{marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"flex-end"}}>
        <div><div style={{fontSize:20,fontWeight:700,color:th.text,marginBottom:3}}>Plan Manager</div><div style={{fontSize:13,color:th.textSec}}>Define plans, pricing, and feature limits for all ZiniZ apps.</div></div>
        <Btn onClick={()=>{const np={id:`plan_${Date.now()}`,label:"New Plan",color:T.teal,colorSoft:T.tealSoft,rank:plans.length,price:{monthly:0,quarterly:0,annual:0},limits:{maxStores:5,maxItemsPerStore:100,maxImagesPerItem:5,maxStaffAccounts:5,maxMediaStorageMB:1000,enableKYC:true,enableOrders:true,enableAnalytics:false}};setDraft(np);setEditingId(np.id);setIsNew(true);}}>+ New Plan</Btn>
      </div>
      <div style={{display:"flex",gap:6,marginBottom:20}}>
        {SUPER_ADMIN_CONFIG.SUBSCRIPTION.VALIDITY_OPTIONS.map(v=>(
          <button key={v} onClick={()=>setActiveV(v)} style={{fontSize:12,fontWeight:500,padding:"5px 14px",borderRadius:99,border:`1px solid ${activeV===v?T.brand:th.borderMd}`,background:activeV===v?T.brandSoft:"transparent",color:activeV===v?T.brand:th.textSec,cursor:"pointer",textTransform:"capitalize"}}>{v}</button>
        ))}
      </div>
      <div ref={el=>targetRefs.current["plan-limits"]=el} style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(210px,1fr))",gap:14,marginBottom:8}}>
        {plans.map(plan=>(
          <div key={plan.id} style={{...card,padding:"16px 18px",borderTop:`3px solid ${plan.color}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <div style={{fontWeight:700,fontSize:14,color:plan.color}}>{plan.label}</div>
              <Btn size="sm" variant="ghost" onClick={()=>startEdit(plan)}>Edit</Btn>
            </div>
            <div style={{fontSize:22,fontWeight:700,color:th.text,marginBottom:2}}>{plan.price[activeV]===0?"Free":`₹${plan.price[activeV]}`}<span style={{fontSize:11,fontWeight:400,color:th.textMuted}}>/{activeV}</span></div>
            <div style={{borderTop:`1px solid ${th.border}`,marginTop:10,paddingTop:10,display:"flex",flexDirection:"column",gap:6}}>
              {LIMITS.map(f=>(
                <div key={f.key} style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
                  <span style={{color:th.textSec}}>{f.label}</span>
                  <span style={{fontWeight:600,color:th.text}}>{f.type==="bool"?(plan.limits[f.key]?<span style={{color:T.green}}>✓</span>:<span style={{color:T.red}}>✗</span>):plan.limits[f.key]===-1?"∞":plan.limits[f.key]}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {editingId&&draft&&(
        <Modal onClose={cancel} title={isNew?"New Plan":`Edit Plan: ${draft.label}`} width={500}>
          <div style={{marginBottom:14}}><FL>Plan Name</FL><FInput value={draft.label} onChange={v=>setDraft(d=>({...d,label:v}))} placeholder="Plan name"/></div>
          <div style={{marginBottom:18}}>
            <div style={{fontSize:13,fontWeight:600,color:"#f1f5f9",marginBottom:9}}>Pricing (₹)</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              {SUPER_ADMIN_CONFIG.SUBSCRIPTION.VALIDITY_OPTIONS.map(v=>(
                <div key={v}><FL style={{textTransform:"capitalize"}}>{v}</FL><FInput value={String(draft.price[v])} onChange={val=>setDraft(d=>({...d,price:{...d.price,[v]:Number(val)}}))} type="number" placeholder="0"/></div>
              ))}
            </div>
          </div>
          <div style={{marginBottom:22}}>
            <div style={{fontSize:13,fontWeight:600,color:"#f1f5f9",marginBottom:9}}>Feature Limits</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {LIMITS.map(f=>(
                <div key={f.key} style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{flex:1}}><div style={{fontSize:12,fontWeight:500,color:"#e2e8f0"}}>{f.label}</div>{f.note&&<div style={{fontSize:11,color:"#64748b"}}>{f.note}</div>}</div>
                  {f.type==="bool"
                    ?<button onClick={()=>setDraft(d=>({...d,limits:{...d.limits,[f.key]:!d.limits[f.key]}}))} style={{width:44,height:24,borderRadius:99,background:draft.limits[f.key]?T.green:"#334155",border:"none",cursor:"pointer",position:"relative",flexShrink:0}}><div style={{width:18,height:18,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:draft.limits[f.key]?23:3,transition:`left ${T.fast} ${T.ease}`}}/></button>
                    :<input type="number" value={draft.limits[f.key]} onChange={e=>setDraft(d=>({...d,limits:{...d.limits,[f.key]:Number(e.target.value)}}))} style={{width:72,fontSize:13,padding:"5px 8px",borderRadius:T.rmd,border:"1px solid rgba(100,116,139,0.35)",textAlign:"right",background:"transparent",color:"#f1f5f9",fontFamily:"inherit",flexShrink:0}}/>}
                </div>
              ))}
            </div>
            <div style={{fontSize:11,color:"#475569",marginTop:8}}>Use -1 for unlimited in number fields.</div>
          </div>
          <div style={{display:"flex",gap:10}}><Btn onClick={save}>Save Plan</Btn><Btn variant="ghost" onClick={cancel}>Cancel</Btn></div>
        </Modal>
      )}
    </div>
  );
}

// ─── BRAND GUIDE MODULE ───────────────────────────────────────────────────────
function BrandGuideModule({th}){
  const [sub,setSub]=useState("colors");
  const card={background:th.surface,border:`1px solid ${th.border}`,borderRadius:T.rlg};
  const SUBS=[
    {id:"colors",label:"Colors"},
    {id:"tokens",label:"Tokens"},
    {id:"ia",label:"IA"},
    {id:"flows",label:"User Flows"},
    {id:"breakpoints",label:"Breakpoints"},
    {id:"config",label:"Config Keys"},
    {id:"devnotes",label:"Dev Notes"},
    {id:"specs",    label:"Component Specs"},
  ];
  const SH=({label,children})=>(
    <div style={{marginBottom:24}}>
      <div style={{fontSize:11,fontWeight:600,color:th.textMuted,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10,paddingBottom:6,borderBottom:`1px solid ${th.border}`}}>{label}</div>
      {children}
    </div>
  );
  const KV=({rows})=>(
    <div style={{...card,overflow:"hidden"}}>
      {rows.map(([k,v,note],i)=>(
        <div key={k} style={{display:"grid",gridTemplateColumns:"200px 1fr",gap:12,padding:"8px 14px",borderBottom:i<rows.length-1?`1px solid ${th.border}`:"none",alignItems:"start"}}>
          <div style={{fontFamily:"monospace",fontSize:11,color:T.cyan,paddingTop:2}}>{k}</div>
          <div>
            <div style={{fontSize:12,color:th.text}}>{v}</div>
            {note&&<div style={{fontSize:11,color:th.textMuted,marginTop:2}}>{note}</div>}
          </div>
        </div>
      ))}
    </div>
  );

  return(
    <div style={{maxWidth:900}}>
      <div style={{marginBottom:20}}>
        <div style={{fontSize:20,fontWeight:700,color:th.text,marginBottom:3}}>Brand Guide & Dev Handoff</div>
        <div style={{fontSize:13,color:th.textSec}}>Single source of truth for brand, tokens, IA, flows, and specs. Hand to devs or AI agents.</div>
      </div>
      {/* Sub-nav */}
      <div style={{display:"flex",gap:4,marginBottom:24,flexWrap:"wrap"}}>
        {SUBS.map(s=>(
          <button key={s.id} onClick={()=>setSub(s.id)} style={{fontSize:12,padding:"5px 14px",borderRadius:99,border:`1px solid ${sub===s.id?T.brand:th.borderMd}`,background:sub===s.id?T.brandSoft:"transparent",color:sub===s.id?T.brand:th.textSec,cursor:"pointer",fontWeight:sub===s.id?600:400}}>{s.label}</button>
        ))}
      </div>

      {sub==="colors"&&(
        <div>
          <SH label="Brand Palette">
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:10}}>
              {BRAND_COLORS.map(c=>(
                <div key={c.name} style={{...card,overflow:"hidden"}}>
                  <div style={{height:40,background:c.hex}}/>
                  <div style={{padding:"8px 10px"}}>
                    <div style={{fontSize:12,fontWeight:600,color:th.text,marginBottom:2}}>{c.name}</div>
                    <div style={{fontFamily:"monospace",fontSize:11,color:T.cyan,marginBottom:4}}>{c.hex}</div>
                    <div style={{fontSize:11,color:th.textMuted,lineHeight:1.4}}>{c.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </SH>
          <SH label="Semantic Usage">
            <KV rows={[
              ["Active / Success","#22C55E on #22C55E18","green text on green-soft bg"],
              ["Expiring Soon","#F59E0B on #F59E0B12","amber text on amber-soft bg"],
              ["Expired / Danger","#EF4444 on #EF444410","red text on red-soft bg"],
              ["Brand accent","#5E4CE2 on rgba(94,76,226,0.12)",""],
              ["Tour spotlight ring","#5E4CE2 2.5px stroke","Canvas 2D clip-path cutout — no double-dim"],
              ["Modal overlay","rgba(0,0,0,0.65) + #2C3149","border-left 3px solid #5E4CE2"],
            ]}/>
          </SH>
          <SH label="Typography Scale">
            <KV rows={[
              ["Page titles","Inter 700 · 20px","color: text-primary"],
              ["Table headers","Inter 600 · 11px uppercase","letter-spacing 0.04em · text-secondary"],
              ["Body / table cells","Inter 400 · 13px","text-primary"],
              ["Helper text","Inter 400 · 12px","text-secondary"],
              ["Muted / meta","Inter 400 · 11px","#94A3B8"],
              ["Stat numbers","Inter 700 · 26–28px","semantic color"],
              ["Badge labels","Inter 600 · 11px","letter-spacing 0.02em"],
              ["Font stack","'Inter', system-ui, -apple-system, sans-serif","Never Arial/Roboto as primary"],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="tokens"&&(
        <div>
          <SH label="Design Tokens">
            <KV rows={TOKEN_TABLE.map(([k,v,r])=>[k,v,r])}/>
          </SH>
          <SH label="Spacing Scale">
            <KV rows={[
              ["4px","Inner icon gap, tight badge padding",""],
              ["8px","Default gap between inline elements",""],
              ["12px","Default grid gap, cell padding",""],
              ["14px","Table cell padding (top/bottom 10px, l/r 14px)",""],
              ["20px","Card padding default",""],
              ["22–26px","Modal inner padding",""],
              ["28–32px","Content area padding (main pane)",""],
            ]}/>
          </SH>
          <SH label="Z-Index Stack">
            <KV rows={[
              ["10","Topbar (sticky above content)",""],
              ["100","Action dropdown menus (⋯)","position:absolute inside row"],
              ["200","Modals (extend, pay link, reset, plan)","position:absolute in content pane"],
              ["9000","Tour overlay","position:fixed — above everything"],
            ]}/>
          </SH>
          <SH label="Layout">
            <KV rows={[
              ["Sidebar expanded","210px fixed left, height:100vh","sticky, transition mid ease"],
              ["Sidebar collapsed","58px icons only",""],
              ["Topbar height","50px","sticky top:0, z-index:10"],
              ["Content padding","26px top/bottom · 28px left/right",""],
              ["maxWidth","1000px","Subscriptions + Plan Manager"],
              ["Modal max-height","82vh overflowY:auto",""],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="ia"&&(
        <div>
          <SH label="Module Overview">
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {IA_MODULES.map(m=>(
                <div key={m.id} style={{...card,padding:"12px 16px",display:"flex",gap:14,alignItems:"flex-start"}}>
                  <span style={{fontSize:20,flexShrink:0,marginTop:1}}>{m.icon}</span>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                      <span style={{fontWeight:600,fontSize:13,color:th.text}}>{m.label}</span>
                      <Badge label={m.status} color={m.status==="live"?T.green:th.textMuted} bg={m.status==="live"?T.greenSoft:th.muted}/>
                    </div>
                    <div style={{fontSize:12,color:th.textSec}}>{m.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </SH>
          <SH label="Subscription Module IA">
            <KV rows={[
              ["Page header","Title + subtitle",""],
              ["Stats row","Total Hubs · Active · Expiring Soon · Expired (live counts)",""],
              ["Search/filter bar","Text search + Status filter + result count",""],
              ["Hub table","HUB · OWNER · PLAN · VALIDITY · EXPIRY · STATUS · ACTIONS",""],
              ["Action: Extend","Days input → new expiry preview → confirm",""],
              ["Action: Pay Link","Plan picker + Validity + amount preview → Generate → Copy",""],
              ["Action: Change Plan","Plan + Validity pickers → warning strip → confirm",""],
              ["Action: Reset PW","Show mobile → confirm → SMS OTP → audit log",""],
            ]}/>
          </SH>
          <SH label="Plan Manager IA">
            <KV rows={[
              ["Page header","Title + subtitle + New Plan CTA",""],
              ["Validity toggle","Monthly / Quarterly / Annual pills","filters price display"],
              ["Plan cards","One card per plan: price + all limit fields","border-top plan.color"],
              ["Edit modal","Name + pricing (3 fields) + limits (number + bool toggles)",""],
              ["Save action","Updates local state → toast 'propagating to DB/S3'",""],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="flows"&&(
        <div>
          {USER_FLOWS.map(flow=>(
            <SH key={flow.id} label={flow.label}>
              <div style={{...card,overflow:"hidden"}}>
                {flow.steps.map((step,i)=>(
                  <div key={i} style={{display:"flex",gap:12,padding:"10px 16px",borderBottom:i<flow.steps.length-1?`1px solid ${th.border}`:"none",alignItems:"flex-start"}}>
                    <div style={{width:22,height:22,borderRadius:"50%",background:flow.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff",flexShrink:0,marginTop:1}}>{i+1}</div>
                    <div>
                      <div style={{fontSize:12,fontWeight:600,color:th.text,marginBottom:2}}>{step.s}</div>
                      <div style={{fontSize:11,color:th.textSec,lineHeight:1.5}}>{step.n}</div>
                    </div>
                  </div>
                ))}
              </div>
            </SH>
          ))}
        </div>
      )}

      {sub==="breakpoints"&&(
        <div>
          <SH label="Viewport Breakpoints">
            <div style={{...card,overflow:"hidden"}}>
              <div style={{display:"grid",gridTemplateColumns:"140px 130px 1fr",gap:0,padding:"8px 16px",background:th.muted,fontSize:10,fontWeight:600,color:th.textMuted,letterSpacing:"0.06em",textTransform:"uppercase"}}>
                {["Breakpoint","Label","Behaviour"].map(h=><div key={h}>{h}</div>)}
              </div>
              {BREAKPOINTS.map(([bp,label,behav],i)=>(
                <div key={bp} style={{display:"grid",gridTemplateColumns:"140px 130px 1fr",gap:0,padding:"10px 16px",borderBottom:i<BREAKPOINTS.length-1?`1px solid ${th.border}`:"none",alignItems:"start"}}>
                  <div style={{fontFamily:"monospace",fontSize:11,color:T.cyan}}>{bp}</div>
                  <div style={{fontSize:12,fontWeight:500,color:th.text}}>{label}</div>
                  <div style={{fontSize:12,color:th.textSec,lineHeight:1.5}}>{behav}</div>
                </div>
              ))}
            </div>
          </SH>
          <SH label="Content Width Constraints">
            <KV rows={[
              ["Subscriptions","maxWidth: 1000px","centered in content pane"],
              ["Plan Manager","maxWidth: 1000px",""],
              ["Modals","440px default · 460px Pay Link","centered, paddingTop 48px"],
              ["Tour tooltip","300px fixed","positioned via window.innerWidth/Height"],
              ["Sidebar expanded","210px","transition mid ease on toggle"],
              ["Sidebar collapsed","58px","emoji-only"],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="config"&&(
        <div>
          <SH label="SUPER_ADMIN_CONFIG Keys">
            <div style={{...card,padding:"12px 16px",marginBottom:14,fontSize:12,color:th.textSec,lineHeight:1.6}}>
              The <span style={{fontFamily:"monospace",color:T.cyan}}>SUPER_ADMIN_CONFIG</span> const is the equivalent of ZiniHub's <span style={{fontFamily:"monospace",color:T.cyan}}>zinihubConfig.js</span> — single source of configurable defaults. Update to change behaviour without touching component code.
            </div>
            <KV rows={CONFIG_KEYS.map(([k,type,desc])=>[k,desc,`type: ${type}`])}/>
          </SH>
          <SH label="Data Model — Hub / Subscription">
            <KV rows={[
              ["id","string","unique hub identifier e.g. 'hub22'"],
              ["name","string","hub display name"],
              ["owner","string","owner full name"],
              ["mobile","string","owner WhatsApp/mobile with country code"],
              ["plan","enum","'trial' | 'starter' | 'professional' | 'enterprise'"],
              ["validity","enum","'monthly' | 'quarterly' | 'annual'"],
              ["expiryDate","ISO date string","subscription expiry (server-computed)"],
              ["status","derived","expired if expiryDate < today; expiring_soon if ≤ 14d; else active"],
              ["app","string","app identifier ('zinihub', 'zinishop' etc.)"],
            ]}/>
          </SH>
          <SH label="Data Model — Plan Definition">
            <KV rows={[
              ["id","string","plan identifier"],
              ["price.monthly / quarterly / annual","number","INR price per validity"],
              ["limits.maxStores","integer","-1 = unlimited"],
              ["limits.maxItemsPerStore","integer","-1 = unlimited"],
              ["limits.maxImagesPerItem","integer",""],
              ["limits.maxStaffAccounts","integer","-1 = unlimited"],
              ["limits.maxMediaStorageMB","integer",""],
              ["limits.enableKYC / enableOrders / enableAnalytics","boolean","feature gates"],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="devnotes"&&(
        <div>
          <SH label="Tech Stack">
            <KV rows={[
              ["Framework","React 18 with hooks (useState, useEffect, useRef)",""],
              ["Bundler","Vite (recommended)",""],
              ["Styling","Inline styles only — no CSS-in-JS, no Tailwind",""],
              ["State","Local component state only — no Redux/Zustand in prototype",""],
              ["Auth","Role check: user must have super_admin role on ZiniHub account",""],
              ["API","All calls mocked — replace MOCK_HUBS / MOCK_PLANS with real endpoints",""],
            ]}/>
          </SH>
          <SH label="Critical Implementation Notes">
            {[
              ["Tour overlay","position:fixed + Canvas 2D clip-path technique. Canvas draws the full-screen dim with a real cutout hole. No double-dim. Canvas width/height set to window.innerWidth/Height explicitly."],
              ["Modals","position:absolute within the scrollable content div — NOT position:fixed (iframe/sandbox breaks fixed modals)."],
              ["Action dropdowns","mousedown outside-click detection via document event listener with useEffect cleanup on close."],
              ["App switcher","Always visible in sidebar regardless of collapsed state. Emoji shown when collapsed."],
              ["Extend validity","New expiry = existing expiryDate + N days — NOT today + N days."],
              ["Plan limits -1","Display as ∞ in the UI everywhere."],
              ["Tour localStorage key","'ziniz_sa_last_tour_v2' — bump version suffix to force-reset all users."],
              ["Cashfree proxy","API keys must be stored server-side (Lambda/backend). Super admin calls your backend which proxies to Cashfree. Never expose x-client-secret to frontend."],
              ["Cashfree endpoint","POST /pg/links · sandbox: sandbox.cashfree.com/pg · prod: api.cashfree.com/pg"],
              ["Audit log (TODO)","Every destructive action (reset PW, change plan, extend) must write: { actor_user_id, target_hub_id, action, payload, timestamp } to audit table."],
            ].map(([k,v])=>(
              <div key={k} style={{...card,padding:"10px 14px",marginBottom:8,display:"flex",gap:12}}>
                <div style={{fontSize:11,fontWeight:600,color:T.brand,width:150,flexShrink:0,lineHeight:1.4}}>{k}</div>
                <div style={{fontSize:12,color:th.textSec,lineHeight:1.6}}>{v}</div>
              </div>
            ))}
          </SH>
          <SH label="File Structure (Production)">
            <KV rows={[
              ["zinizSuperAdminConfig.js","Extract SUPER_ADMIN_CONFIG from top of main file",""],
              ["brandTokens.js","Extract T — shared with ZiniHub",""],
              ["mockData.js","Extract MOCK_HUBS + MOCK_PLANS",""],
              ["tourSteps.js","Extract TOUR_STEPS for easy content editing",""],
              ["components/Modal.jsx","Shared modal component",""],
              ["modules/SubscriptionModule.jsx","",""],
              ["modules/PlanManagerModule.jsx","",""],
              ["modules/BrandGuideModule.jsx","",""],
            ]}/>
          </SH>
        </div>
      )}

      {sub==="specs"&&(
        <div>
          {/* ── Component by component specs like zinihub wizard ── */}
          {[
            {
              id:"sidebar",title:"Sidebar",color:T.brand,
              fields:[
                {label:"Width expanded",value:"210px",type:"token",note:"SW=210"},
                {label:"Width collapsed",value:"58px",type:"token",note:"icons only"},
                {label:"Transition",value:"width 220ms cubic-bezier(0.4,0,0.2,1)",type:"style"},
                {label:"Background dark",value:"#0D1017",type:"color"},
                {label:"Background light",value:"#FFFFFF",type:"color"},
                {label:"Logo zone",value:"28×28px ⚡ bolt + ZiniZ Super Admin 13px/700",type:"layout"},
                {label:"App switcher",value:"Always visible. APP label 10px/600/uppercase. Each app: emoji+name+desc. Active: brand border+bg. Disabled: opacity 0.4",type:"component"},
                {label:"Nav item height",value:"~34px (7px 9px padding)",type:"token"},
                {label:"Nav active",value:"brandSoft bg + brand text/600",type:"style"},
                {label:"Nav soon badge",value:"9px pill · muted bg",type:"style"},
                {label:"Bottom bar items",value:"Viewport toggle · Dark mode · Site tour · Brand Guide",type:"layout"},
              ]
            },
            {
              id:"topbar",title:"Topbar",color:T.cyan,
              fields:[
                {label:"Height",value:"50px",type:"token"},
                {label:"z-index",value:"10",type:"token"},
                {label:"Left content",value:"☰ hamburger 17px + breadcrumb 'ZiniZ › App › Module' 13px",type:"layout"},
                {label:"Right content",value:"🔐 Super Admin badge (11px pill) + SA avatar 30×30",type:"layout"},
                {label:"Badge bg",value:"th.muted + th.border",type:"style"},
                {label:"Avatar",value:"brandSoft bg + brand text + 'SA' initials 12px/700",type:"style"},
              ]
            },
            {
              id:"stats",title:"Stats Cards",color:T.amber,
              fields:[
                {label:"Grid",value:"4 columns, gap 12px",type:"layout"},
                {label:"Card",value:"surface bg + border + radius 16px + padding 14px 18px",type:"style"},
                {label:"Label",value:"11px · textMuted · margin-bottom 4px",type:"style"},
                {label:"Value",value:"28px / 700 · semantic color per stat",type:"style"},
                {label:"Colors",value:"Total=brand · Active=green · Expiring=amber · Expired=red",type:"semantic"},
              ]
            },
            {
              id:"search_bar",title:"Search / Filter Bar",color:T.teal,
              fields:[
                {label:"Layout",value:"Flex row: search input (flex:1) · status select · result count",type:"layout"},
                {label:"Container",value:"surface bg + border + radius 16px + padding 12px 16px",type:"style"},
                {label:"Input bg",value:"rgba(255,255,255,0.04)",type:"color"},
                {label:"Input border",value:"1px solid rgba(100,116,139,0.3)",type:"style"},
                {label:"Select bg dark",value:"T.dMuted (#1E2330)",type:"color"},
                {label:"Select bg light",value:"T.lSurface (#FFFFFF)",type:"color"},
                {label:"Result count",value:"12px · textMuted · whitespace nowrap",type:"style"},
              ]
            },
            {
              id:"hub_table",title:"Hub Table",color:T.violet,
              fields:[
                {label:"Header",value:"muted bg + border-bottom + 11px/600 uppercase + letter-spacing 0.04em",type:"style"},
                {label:"Row height",value:"~50px (two-line cells: name+meta)",type:"token"},
                {label:"Alt rows",value:"even: transparent · odd: th.muted at 33% opacity",type:"style"},
                {label:"Hub cell",value:"Hub name 600/primary + ID·app 11px/muted",type:"layout"},
                {label:"Owner cell",value:"Name primary + mobile 11px/muted",type:"layout"},
                {label:"Expiry coloring",value:"< 0d = red · < 14d = amber · else muted",type:"semantic"},
                {label:"Actions cell",value:"⋯ button → dropdown with 4 actions",type:"component"},
                {label:"⋯ button inactive",value:"rgba(255,255,255,0.05) bg + rgba(255,255,255,0.1) border",type:"style"},
                {label:"⋯ button active",value:"brandSoft bg + brandBorder border + brand color",type:"style"},
              ]
            },
            {
              id:"action_dropdown",title:"Action Dropdown (⋯)",color:T.coral,
              fields:[
                {label:"Position",value:"absolute right:0 top:calc(100%+6px) z-index:100",type:"layout"},
                {label:"Bg dark",value:"#252C3D",type:"color"},
                {label:"Bg light",value:"#FFFFFF",type:"color"},
                {label:"Border dark",value:"1px solid rgba(255,255,255,0.12)",type:"style"},
                {label:"Min width",value:"175px",type:"token"},
                {label:"Item",value:"flex row: 6px color dot + label 12px + hover bg",type:"layout"},
                {label:"Items",value:"Extend validity (brand) · Generate pay link (green) · Change plan (amber) · Reset password (red)",type:"semantic"},
                {label:"Close",value:"mousedown outside via useEffect cleanup",type:"behaviour"},
              ]
            },
            {
              id:"modal",title:"Action Modals",color:T.green,
              fields:[
                {label:"Backdrop",value:"position:absolute inset:0 rgba(0,0,0,0.65) z-index:200",type:"layout",note:"NOT position:fixed — iframe safe"},
                {label:"Align",value:"flex alignItems:flex-start justifyContent:center paddingTop:48px",type:"layout"},
                {label:"Surface dark",value:"#2C3149",type:"color",note:"Must contrast with #111318 canvas"},
                {label:"Surface light",value:"#FFFFFF",type:"color"},
                {label:"Border",value:"border-left 3px solid brand + 1px solid rgba(94,76,226,0.4)",type:"style"},
                {label:"Shadow",value:"0 24px 64px rgba(0,0,0,0.7) + 0 0 0 1px rgba(94,76,226,0.15)",type:"style"},
                {label:"Width default",value:"440px",type:"token"},
                {label:"Width pay link",value:"460px",type:"token"},
                {label:"Max height",value:"82vh overflowY:auto",type:"token"},
                {label:"Padding",value:"22px 26px",type:"token"},
                {label:"Close btn",value:"rgba(255,255,255,0.1) bg + 1px border + rsm radius + 3px 9px padding",type:"style"},
                {label:"Info strip",value:"rgba(94,76,226,0.12) bg + rgba(94,76,226,0.2) border + 8px 12px padding + 12px text",type:"style"},
                {label:"Warn strip",value:"amberSoft bg + amber border + amber 12px text",type:"style"},
              ]
            },
            {
              id:"plan_cards",title:"Plan Cards",color:T.amber,
              fields:[
                {label:"Grid",value:"auto-fit minmax(210px,1fr) gap 14px",type:"layout"},
                {label:"Border top",value:"3px solid plan.color",type:"style"},
                {label:"Plan name",value:"14px/700 plan.color",type:"style"},
                {label:"Price",value:"22px/700 primary + /validity 11px/400 muted",type:"style"},
                {label:"Limit row",value:"justify space-between · 12px · textSec vs text",type:"layout"},
                {label:"Bool limit",value:"green ✓ or red ✗",type:"semantic"},
                {label:"Unlimited",value:"-1 displays as ∞",type:"behaviour"},
                {label:"Edit btn",value:"ghost variant sm size · right aligned",type:"component"},
              ]
            },
            {
              id:"tour",title:"Site Tour",color:T.brand,
              fields:[
                {label:"Overlay",value:"position:fixed inset:0 z-index:9000 pointerEvents:none",type:"layout"},
                {label:"Dim technique",value:"HTML5 Canvas · canvas.width=window.innerWidth · evenodd fill rule for cutout",type:"behaviour",note:"Single draw call — no double-dim"},
                {label:"Spotlight ring",value:"brand color 2.5px stroke on canvas",type:"style"},
                {label:"Spotlight clamp",value:"x=Math.max(1,x-pad) prevents left bleed",type:"behaviour"},
                {label:"Tooltip bg",value:"#1E2540",type:"color"},
                {label:"Tooltip border",value:"2px solid brand",type:"style"},
                {label:"Tooltip width",value:"308px fixed",type:"token"},
                {label:"Tooltip position",value:"prefer below target · flip above if near viewport bottom",type:"behaviour"},
                {label:"Progress dots",value:"active: 14px width brand · inactive: 5px rgba(255,255,255,0.18)",type:"style"},
                {label:"localStorage key",value:"'ziniz_sa_last_tour_v2'",type:"behaviour",note:"Bump version to reset all users"},
                {label:"Idle threshold",value:"SUPER_ADMIN_CONFIG.TOUR.IDLE_DAYS_TRIGGER (default 30 days)",type:"config"},
                {label:"Re-trigger",value:"🧭 Site tour in sidebar bottom",type:"behaviour"},
              ]
            },
            {
              id:"buttons",title:"Buttons & Controls",color:T.cyan,
              fields:[
                {label:"primary",value:"brand bg + white text",type:"variant"},
                {label:"ghost",value:"transparent bg + brand text + brandBorder border",type:"variant"},
                {label:"danger",value:"redSoft bg + red text",type:"variant"},
                {label:"success",value:"greenSoft bg + green text",type:"variant"},
                {label:"amber",value:"amberSoft bg + amber text",type:"variant"},
                {label:"neutral",value:"rgba(255,255,255,0.07) bg + rgba white border",type:"variant"},
                {label:"size sm",value:"12px · 5px 11px padding",type:"token"},
                {label:"size md",value:"13px · 7px 16px padding",type:"token"},
                {label:"disabled",value:"cursor not-allowed + opacity 0.45",type:"state"},
                {label:"radius",value:"rmd (10px)",type:"token"},
                {label:"transition",value:"fast ease",type:"token"},
              ]
            },
          ].map(comp=>(
            <div key={comp.id} style={{...card,overflow:"hidden",marginBottom:16}}>
              <div style={{padding:"10px 16px",borderBottom:`1px solid ${th.border}`,borderLeft:`3px solid ${comp.color}`,display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontWeight:700,fontSize:13,color:comp.color}}>{comp.title}</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"160px 1fr",gap:0}}>
                {comp.fields.map((f,i)=>(
                  <React.Fragment key={f.label}>
                    <div style={{padding:"7px 14px",borderBottom:i<comp.fields.length-1?`1px solid ${th.border}`:"none",background:th.muted,display:"flex",alignItems:"flex-start",gap:6}}>
                      <span style={{fontFamily:"monospace",fontSize:10,color:T.cyan,lineHeight:1.5}}>{f.label}</span>
                    </div>
                    <div style={{padding:"7px 14px",borderBottom:i<comp.fields.length-1?`1px solid ${th.border}`:"none"}}>
                      <div style={{fontSize:12,color:th.text,lineHeight:1.5}}>{f.value}</div>
                      {f.note&&<div style={{fontSize:11,color:th.textMuted,marginTop:2}}>{f.note}</div>}
                      <span style={{fontSize:9,fontWeight:600,color:
                        f.type==="color"?T.cyan:f.type==="token"?T.amber:f.type==="semantic"?T.green:f.type==="behaviour"?T.coral:f.type==="config"?T.brand:th.textMuted,
                        background:th.muted,borderRadius:3,padding:"1px 5px",marginTop:4,display:"inline-block"
                      }}>{f.type}</span>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── APP SWITCHER ─────────────────────────────────────────────────────────────
function AppSwitcher({activeApp,onSwitch,open,targetRef}){
  return(
    <div ref={targetRef} style={{padding:"10px 10px",borderBottom:"1px solid rgba(255,255,255,0.07)"}}>
      {open&&<div style={{fontSize:10,color:"#475569",letterSpacing:"0.07em",fontWeight:600,marginBottom:7,paddingLeft:4}}>APP</div>}
      {SUPER_ADMIN_CONFIG.APPS.map(app=>{
        const isActive=activeApp===app.id;
        return(
          <div key={app.id} onClick={()=>!app.disabled&&onSwitch(app.id)}
            style={{display:"flex",alignItems:"center",gap:9,padding:open?"7px 8px":"8px",borderRadius:T.rmd,cursor:app.disabled?"not-allowed":"pointer",marginBottom:3,background:isActive?`${app.color}18`:"transparent",border:isActive?`1px solid ${app.color}44`:"1px solid transparent",opacity:app.disabled?0.4:1,transition:`all ${T.fast} ${T.ease}`}}>
            <span style={{fontSize:open?15:18,flexShrink:0}}>{app.emoji}</span>
            {open&&<>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,color:isActive?app.color:"#b0bec5",lineHeight:1.2}}>{app.label}</div>
                <div style={{fontSize:10,color:"#475569",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{app.desc}</div>
              </div>
              {isActive&&<div style={{width:6,height:6,borderRadius:"50%",background:app.color,flexShrink:0}}/>}
            </>}
          </div>
        );
      })}
    </div>
  );
}

// ─── NAV ITEMS ────────────────────────────────────────────────────────────────
const NAV_ITEMS=[
  {id:"subscriptions",label:"Subscriptions",icon:"💳",refKey:"nav-sub"},
  {id:"plans",        label:"Plan Manager", icon:"📦",refKey:"nav-plans"},
  {id:"users",        label:"Users",        icon:"👥",soon:true},
  {id:"app_config",   label:"App Config",   icon:"⚙️", soon:true},
  {id:"feature_flags",label:"Feature Flags",icon:"🚩",soon:true},
  {id:"audit_log",    label:"Audit Log",    icon:"📋",soon:true},
];

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function ZiniZSuperAdmin(){
  const [dark,setDark]=useState(true);
  const [section,setSection]=useState("subscriptions");
  const [sidebarOpen,setSidebarOpen]=useState(true);
  const [activeApp,setActiveApp]=useState("zinihub");
  const [tourActive,setTourActive]=useState(false);
  const [tourStep,setTourStep]=useState(0);
  const [viewport,setViewport]=useState("desktop"); // "desktop"|"mobile"
  const targetRefs=useRef({});
  const th=useTheme(dark);

  useEffect(()=>{
    // localStorage may be blocked in sandboxed iframes — read safely
    // but always default to showing tour if we can't read the key
    let shouldShow = true;
    try{
      const last=localStorage.getItem("ziniz_sa_last_tour_v2");
      const idle=SUPER_ADMIN_CONFIG.TOUR.IDLE_DAYS_TRIGGER;
      if(last && (Date.now()-parseInt(last))<=(idle*86400000)) shouldShow=false;
    }catch(e){ shouldShow=true; } // if localStorage blocked → always show
    if(shouldShow) setTimeout(()=>setTourActive(true),800);
  },[]);

  const handleTourNext=()=>{
    if(tourStep<TOUR_STEPS.length-1){
      const next=TOUR_STEPS[tourStep+1];
      if(["nav_sub","sub_search","sub_table"].includes(next.id)) setSection("subscriptions");
      if(["nav_plans","plan_cards"].includes(next.id)) setSection("plans");
      setTourStep(s=>s+1);
    } else { endTour(); }
  };
  const endTour=()=>{
    setTourActive(false);setTourStep(0);
    try{localStorage.setItem("ziniz_sa_last_tour_v2",String(Date.now()));}catch(e){
      // localStorage blocked in sandboxed iframe — tour will show again on next load
    }
  };

  const SW=sidebarOpen?210:58;

  const appBody=(
    <div style={{display:"flex",flex:1,minHeight:0,minWidth:0,height:"100%"}}>
      {/* SIDEBAR */}
      <div style={{width:SW,background:th.sidebar,borderRight:`1px solid ${th.border}`,display:"flex",flexDirection:"column",transition:`width ${T.mid} ${T.ease}`,overflow:"hidden",flexShrink:0}}>
        <div style={{padding:"15px 12px 13px",borderBottom:`1px solid ${th.border}`,display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:28,height:28,borderRadius:T.rmd,background:T.brand,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>⚡</div>
          {sidebarOpen&&<div style={{fontWeight:700,fontSize:13,color:th.text,whiteSpace:"nowrap"}}>ZiniZ Super Admin</div>}
        </div>
        <AppSwitcher activeApp={activeApp} onSwitch={setActiveApp} open={sidebarOpen} targetRef={el=>targetRefs.current["app-switcher"]=el}/>
        <nav style={{flex:1,padding:"8px 8px",overflowY:"auto"}}>
          {sidebarOpen&&<div style={{fontSize:10,color:"#475569",letterSpacing:"0.07em",fontWeight:600,marginBottom:6,paddingLeft:4,marginTop:4}}>MODULES</div>}
          {NAV_ITEMS.map(item=>{
            const active=section===item.id;
            return(
              <div key={item.id} ref={el=>{if(item.refKey)targetRefs.current[item.refKey]=el;}} onClick={()=>!item.soon&&setSection(item.id)}
                style={{display:"flex",alignItems:"center",gap:9,padding:sidebarOpen?"7px 9px":"8px",borderRadius:T.rmd,cursor:item.soon?"not-allowed":"pointer",marginBottom:2,background:active?T.brandSoft:"transparent",color:active?T.brand:item.soon?th.textMuted:th.textSec,transition:th.tr}}>
                <span style={{fontSize:15,flexShrink:0}}>{item.icon}</span>
                {sidebarOpen&&<span style={{fontSize:12,fontWeight:active?600:400,whiteSpace:"nowrap",flex:1}}>{item.label}</span>}
                {sidebarOpen&&item.soon&&<span style={{fontSize:9,color:"#475569",background:th.muted,borderRadius:99,padding:"1px 6px",flexShrink:0}}>soon</span>}
              </div>
            );
          })}
        </nav>
        <div style={{padding:"8px",borderTop:`1px solid ${th.border}`}}>
          <div onClick={()=>{setTourStep(0);setTourActive(true);}} style={{display:"flex",alignItems:"center",gap:9,padding:sidebarOpen?"6px 9px":"8px",borderRadius:T.rmd,cursor:"pointer",color:th.textMuted,fontSize:12}}>
            <span style={{fontSize:15}}>🧭</span>
            {sidebarOpen&&<span>Site tour</span>}
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0,overflow:"hidden"}}>
        <div style={{height:50,borderBottom:`1px solid ${th.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 22px",background:th.surface,flexShrink:0,zIndex:10}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button onClick={()=>setSidebarOpen(v=>!v)} style={{background:"none",border:"none",cursor:"pointer",color:th.textSec,fontSize:17,padding:0}}>☰</button>
            <div style={{fontSize:13,color:th.textMuted}}>
              <span style={{color:T.brand,fontWeight:600}}>ZiniZ</span> › {SUPER_ADMIN_CONFIG.APPS.find(a=>a.id===activeApp)?.label} › {NAV_ITEMS.find(n=>n.id===section)?.label||"—"}
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{fontSize:11,color:th.textMuted,background:th.muted,padding:"3px 10px",borderRadius:99,border:`1px solid ${th.border}`}}>🔐 Super Admin</div>
            <div style={{width:30,height:30,borderRadius:"50%",background:T.brandSoft,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:T.brand}}>SA</div>
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"26px 28px",position:"relative"}}>
          {section==="subscriptions"&&<SubscriptionModule th={th} targetRefs={targetRefs}/>}
          {section==="plans"&&<PlanManagerModule th={th} targetRefs={targetRefs}/>}
          {!["subscriptions","plans"].includes(section)&&(
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:300,gap:10}}>
              <div style={{fontSize:38}}>🚧</div>
              <div style={{fontSize:17,fontWeight:600,color:th.text}}>Coming Soon</div>
              <div style={{fontSize:13,color:th.textSec}}>This module is on the roadmap.</div>
            </div>
          )}
        </div>
      </div>

      {tourActive&&<TourOverlay step={TOUR_STEPS[tourStep]} stepIdx={tourStep} total={TOUR_STEPS.length} onNext={handleTourNext} onSkip={endTour} targetRefs={targetRefs}/>}
    </div>
  );

  return (
    <PrototypeChrome
      dark={dark}
      setDark={setDark}
      title="ZiniZ Super Admin Prototype"
      domain="superadmin.ziniz.online"
      viewport={viewport}
      onViewportChange={setViewport}
    >
      {appBody}
    </PrototypeChrome>
  );
}
